import {
  SeeDeviceCatalogPermissionDocument,
  type SeeDeviceCatalogPermissionQuery,
  type SeeDeviceCatalogPermissionQueryVariables,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useSeeDeviceCatalogPermission = (): boolean => {
  const { data } = useQuery<
    SeeDeviceCatalogPermissionQuery,
    SeeDeviceCatalogPermissionQueryVariables
  >(SeeDeviceCatalogPermissionDocument)

  return data?.itManagement._policies.sidebarSeeDeviceCatalogItem.can ?? false
}
